// extracted by mini-css-extract-plugin
export default {"container":"SwitchRow_container__lbbgI"};